import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=7e44d8ec&scoped=true"
import script from "./SummaryOrder.vue?vue&type=script&lang=ts"
export * from "./SummaryOrder.vue?vue&type=script&lang=ts"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=7e44d8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e44d8ec",
  null
  
)

export default component.exports